import { httpsCallable } from 'firebase/functions';
import { functions } from './firebase';

export interface CompanyFinancePoSummary {
  purchaseOrderId: string | null;
  poNumber: string;
  paid: number;
  open: number;
  overdue: number;
  pending: number;
}

export interface CompanyFinanceSummary {
  customerId: string;
  customerName: string;
  paid: number;
  open: number;
  overdue: number;
  pending: number;
  poSummaries: CompanyFinancePoSummary[];
}

export interface CompanyFinanceReport {
  summary: CompanyFinanceSummary | null;
  generatedAt: string | null;
  staleAfter: string | null;
  status: string | null;
  pendingRevenuePeriodStart: string | null;
}

const getFinanceReportFn = httpsCallable<
  { alignedCustomerId: string },
  CompanyFinanceReport
>(functions, 'getAlignedCompanyFinanceReport');

export async function getCompanyFinanceReport(alignedCustomerId: string): Promise<CompanyFinanceReport> {
  const result = await getFinanceReportFn({ alignedCustomerId });
  return result.data;
}
